import { initializeApp, type FirebaseApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
} from 'firebase/auth'
import { getAnalytics, logEvent, setCurrentScreen } from 'firebase/analytics'
import { envConfig } from './envConfig'

const firebaseConfig = {
  apiKey: envConfig.NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY,
  authDomain: envConfig.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: envConfig.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: envConfig.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: envConfig.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: envConfig.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: envConfig.NEXT_PUBLIC_MEASUREMENT_ID,
}

let app: FirebaseApp | undefined

const getFirebaseApp = () => {
  if (typeof window === 'undefined') {
    throw new Error('Firebase is only available on the client')
  }
  if (!app) {
    app = initializeApp(firebaseConfig)
  }
  return app
}

const analytics = () => {
  // Allow import on server, but only callable on client
  if (typeof window === 'undefined') {
    return undefined as any
  }
  return getAnalytics(getFirebaseApp())
}

const auth = () => {
  if (typeof window === 'undefined') {
    return undefined as any
  }
  return getAuth(getFirebaseApp())
}

const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider()
  return signInWithPopup(auth(), provider)
}

const signInWithGoogleRedirect = async () => {
  const provider = new GoogleAuthProvider()
  return signInWithRedirect(auth(), provider)
}

export {
  analytics,
  auth,
  signInWithGoogle,
  signInWithGoogleRedirect,
  GoogleAuthProvider,
  logEvent,
  setCurrentScreen,
}
